import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BtnOutlined,
  CmbWithTitle,
  Column,
  ContainerInside,
  Items,
} from "../styled.components";
import FooterBtns from "../FooterBtns";
import { cloneObjectWithRegExp, hotToast, validateData } from "utils";
import { InputsGroup } from "Components/Inputs";
import { InputModal } from "Components/V1/InputModal";
import Table from "Components/V1/Table";
import SaveIcon from "@mui/icons-material/Save";
import ServiceArchivo from "service/archivos";
import { ICombo } from "Interfaces/Generics";
import IRelUsuarioMarcaOperacion from "ITables/RelUsuarioMarcaOperacion";
import DragFile from "Components/V1/DragFile";

const SCHEMADATA = {
  idArchivo: {
    error: false,
    required: true,
    type: "select",
    textError: "Ingresa un un archivo valido",
  },
  idMarca: {
    error: false,
    required: true,
    type: "select",
    textError: "Ingresa una marca valido",
  },
  idTipoOperacion: {
    error: false,
    required: true,
    type: "select",
    textError: "Ingresa un tipo de operacion valida",
  },
  fechaAplicacion: {
    error: false,
    required: true,
    type: "date",
    textError: "Ingresa una fecha valida",
    notValidate: true
  },
};

interface IUploadFile {
  idArchivo: number;
  idMarca: number;
  idTipoOperacion: number;
  fechaAplicacion: string;
}

const CreateNewFile = ({
  reloadData,
  closeModal,
  loading,
  setLoading,
}: any) => {
  const [dataFile, setDataFile] = useState<any>({
    idArchivo: 0,
    idMarca: 0,
    idTipoOperacion: 0,
    fechaAplicacion: "",
  });
  const [validate, setValidate] = useState(cloneObjectWithRegExp(SCHEMADATA));
  const [file, setFile] = useState<any>(null);

  const [arrayArchivos, setArrayArchivos] = useState<Array<ICombo>>([]);
  const [arrayMarcas, setArrayMarcas] = useState<Array<ICombo>>([]);
  const [arrayTiposOperacion, setArrayTiposOperacion] = useState<Array<ICombo>>(
    []
  );

  useEffect(() => {
    ServiceArchivo.cmbFilesUser(setArrayArchivos);
  }, []);

  const handleArchivo = (e: any) => {
    let value = e.target.value;
    setValidate((old: any) => ({
      ...old,
      idArchivo: { ...old["idArchivo"], error: false },
    }));
    ServiceArchivo.cmbBrandsByUser({
      setterFunc: setArrayMarcas,
      idFile: e.target.value,
    });
    setDataFile((old: any) => ({
      ...old,
      idArchivo: value,
      idMarca: 0,
      idTipoOperacion: 0,
    }));
    setArrayTiposOperacion([]);
  };
  const handleMarca = (e: any) => {
    let value = e.target.value;
    setValidate((old: any) => ({
      ...old,
      idMarca: { ...old["idMarca"], error: false },
    }));
    ServiceArchivo.cmbOperationsByUser({
      setterFunc: setArrayTiposOperacion,
      idFile: dataFile.idArchivo,
      idBrand: e.target.value,
    });
    setDataFile((old: any) => ({
      ...old,
      idMarca: value,
      idTipoOperacion: 0,
    }));
  };
  const handleChange = (e: any) => {
    let value = e.target.value;
    let name = e.target.getAttribute
      ? e.target.getAttribute("name")
      : e.target.name;

    setValidate({
      ...validate,
      [name]: {
        ...validate[name],
        error: false,
      },
    });
    setDataFile({
      ...dataFile,
      [name]: value,
    });
  };

  const onSubmit = async () => {
    let flag = validateData({ validate, data: dataFile }, setValidate);
    if (!file) {
      return hotToast("Selecciona un archivo", "WAR");
    }
    setLoading(true);
    if (!flag) {
      let formData = new FormData();

      for (let key in dataFile as any) {
        formData.append(key, dataFile[key]);
      }
      formData.append("file", file);
      let response = await ServiceArchivo.postUploadFile({ data: formData });
      if (response) {
        hotToast("El registro se guardo correctamente", "SUCCESS");
        reloadData && reloadData();
        closeModal && closeModal();
        setValidate(SCHEMADATA);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  return (
    <ContainerInside>
      <InputsGroup>
        <CmbWithTitle error={validate.idArchivo.error}>
          <span>Nombre de Archivo:</span>
          <InputModal
            name="idArchivo"
            id="slcIdArchivo"
            minWidth={"300px"}
            onChange={handleArchivo}
            value={dataFile.idArchivo}
            select
            error={validate.idArchivo.error}
            helperText={
              validate.idArchivo.error && validate.idArchivo.textError
            }
          >
            {arrayArchivos &&
              arrayArchivos.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                );
              })}
          </InputModal>
        </CmbWithTitle>
        <CmbWithTitle error={validate.idArchivo.error}>
          <span>Marca:</span>
          <InputModal
            name="idMarca"
            id="slcIdMarca"
            minWidth={"300px"}
            onChange={handleMarca}
            value={dataFile.idMarca}
            select
            error={validate.idMarca.error}
            helperText={validate.idMarca.error && validate.idMarca.textError}
          >
            {arrayMarcas &&
              arrayMarcas.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                );
              })}
          </InputModal>
        </CmbWithTitle>
      </InputsGroup>

      <InputsGroup>
        <CmbWithTitle error={validate.idArchivo.error}>
          <span>Tipo de Operación</span>
          <InputModal
            name="idTipoOperacion"
            id="slcIdTipoOperacion"
            minWidth={"300px"}
            onChange={handleChange}
            value={dataFile.idTipoOperacion}
            select
            error={validate.idTipoOperacion.error}
            helperText={
              validate.idTipoOperacion.error &&
              validate.idTipoOperacion.textError
            }
          >
            {arrayTiposOperacion &&
              arrayTiposOperacion.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                );
              })}
          </InputModal>
        </CmbWithTitle>
        <CmbWithTitle error={validate.idArchivo.error}>
          <span>Fecha aplicación</span>
          <InputModal
            name="fechaAplicacion"
            id="slcFechaAplicacion"
            minWidth={"300px"}
            onChange={handleChange}
            type="date"
            value={dataFile.fechaAplicacion}
            error={validate.fechaAplicacion.error}
            helperText={
              validate.fechaAplicacion.error &&
              validate.fechaAplicacion.textError
            }
          />
        </CmbWithTitle>
      </InputsGroup>
      <Items>
        <DragFile file={file} disabled={false} setterFunc={setFile} />
      </Items>

      <FooterBtns
        handleCancel={closeModal}
        handleSubmit={onSubmit}
        loader={loading}
      />
    </ContainerInside>
  );
};

export default CreateNewFile;
